import { DateRange, ExperimentFilters, MetricRange } from "../../domain/experiment.entity";

export const experimentsQueryKeys = {
  all: ["orchestratorExperiments"] as const,
  lists: () => [...experimentsQueryKeys.all, "list"] as const,
  list: (propertyTicker: string, filters: ExperimentFilters) =>
    [...experimentsQueryKeys.lists(), { propertyTicker, filters }] as const,
  details: () => [...experimentsQueryKeys.all, "detail"] as const,
  detail: (propertyTicker: string, id: string) =>
    [...experimentsQueryKeys.details(), propertyTicker, id] as const,
  results: () => [...experimentsQueryKeys.all, "results"] as const,
  /**
   * `custom` narrows the window only when the range IS "CUSTOM" (`resolveMetricRange` ignores it
   * otherwise), so it is normalised out of the key for every other range. Without this, a stale
   * custom pick left behind by a previous selection forked one FULL query into two cache entries
   * — the sections that pass `custom` unconditionally on one key, the chart on another — and the
   * same results were fetched twice.
   */
  result: (propertyTicker: string, id: string, range: MetricRange, custom?: DateRange) =>
    [
      ...experimentsQueryKeys.results(),
      propertyTicker,
      id,
      range,
      range === "CUSTOM" ? custom : undefined,
    ] as const,
};
